export default __webpack_public_path__ + "static/bubble-with-categories-f17fae852601a444c5054a55d4f73129.png";